import { useEffect, useState } from 'react';

// Log the backend version banner only once per page load (StrictMode double-mount safe).
let loggedOnce = false;

/**
 * Fetches the running backend version from /api/health, logs it to the browser console
 * once on load, and returns it for display in the UI.
 */
export function useVersion(): string {
  const [version, setVersion] = useState<string>('…');

  useEffect(() => {
    let cancelled = false;
    // Raw fetch is a deliberate exception to the "use react-proto-kit" rule: /health is
    // unauthenticated and returns a bare object, not the {success,data} envelope the
    // proto-kit connector expects. The /api prefix resolves same-origin in both dev
    // (vite proxy) and prod (Caddy strips /api → backend /health).
    fetch('/api/health')
      .then((r) => r.json())
      .then((h: { version?: string }) => {
        if (cancelled) return;
        const v = h.version ?? 'unknown';
        setVersion(v);
        if (!loggedOnce) {
          loggedOnce = true;
          // biome-ignore lint/suspicious/noConsole: intentional version banner
          console.log(
            `%c🚀 noten backoffice %c${v}`,
            'font-weight:bold',
            'font-weight:bold;color:#6366f1',
          );
        }
      })
      .catch(() => {
        if (!cancelled) setVersion('unknown');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return version;
}
